import React, {Component} from 'react';
import '../styles/Home.css'
import * as acc from "accounting";
import QRCode from "qrcode.react";
import {Button} from "react-bootstrap";
import KoszykService from "../koszyk/KoszykService";
import AppConfig from "../AppConfig";
import {NotificationManager} from "react-notifications";

export default class Transakcja extends Component {

    constructor(props) {
        super(props);

        this.state = {
            bilety: [],
            loading: true,
            onRegister: false,
        }
    }

    componentWillMount() {
        KoszykService.getTransakcja(this.props.match.params.transakcja).then(function (response) {
            sessionStorage.removeItem('platnosc');
            this.setState({bilety: response.data, loading: false})
        }.bind(this));
        // KoszykService.getPotwierdzenie(this.props.match.params.transakcja).then(function (response) {
        // }.bind(this)).catch(error => {
        //     NotificationManager.warning("", "Bilety nie zostały opłacone lub jeśli płatność jest w trakcie - proszę odświeżyć stronę ", 5000)
        // })
    }

    anulujBilet(item) {
        this.setState({loading: true});
        KoszykService.putAnulujTransakcje(item.idBi, this.props.match.params.transakcja).then(function (response) {
            this.componentWillMount();
            NotificationManager.warning("", "Bilet został anulowany ", 5000)
        }.bind(this))
    }

    checkStatus(status) {
        if (status === -1) {
            return <span style={{fontWeight: 'bold', background: '#dc3545', color: 'white', borderRadius: 5, padding: '4px 8px'}}>DO OPŁACENIA</span>
        } else {
            if (status === 0) {
                return <span style={{fontWeight: 'bold', background: '#17a2b8', color: 'white', borderRadius: 5, padding: '4px 8px'}}>REZERWACJA</span>
            } else {
                if (status === 1) {
                    return <span style={{fontWeight: 'bold', background: '#57b13c', color: 'white', borderRadius: 5, padding: '4px 8px'}}>OPŁACONY</span>
                } else {
                    if (status === 2) {
                        return <span style={{fontWeight: 'bold', background: '#ffa707', color: 'white', borderRadius: 5, padding: '4px 8px'}}>SKASOWANY</span>
                    } else {
                        if (status === -2 || status === -3) {
                            return <span style={{fontWeight: 'bold', background: '#dc3545', color: 'white', borderRadius: 5, padding: '4px 8px'}}>ANULOWANO</span>
                        } else {
                            if (status === -4) {
                                return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>ZWRÓCONO</span>
                            } else {
                                if (status === -5) {
                                    return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>NIEOPŁACONY</span>
                                } else {
                                    if (status === -6) {
                                        return <span style={{fontWeight: 'bold', background: '#929292', color: 'white', borderRadius: 5, padding: '4px 8px'}}>PŁAT. ZWRÓCONA</span>
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    checkWazny(item) {
        return <div><i className="fa fa-calendar"
                       style={{paddingLeft: 2, paddingRight: 2, color: '#696969'}}></i> {item.waznyDo}</div>
    }

    checkWaznyCzas(item) {
        return <div><i className="fa fa-clock-o"
                       style={{paddingLeft: 10, paddingRight: 2, color: '#696969'}}></i>{item.godz}</div>
    }

    render() {
        return <div className="container">

            <hr/>
            <div className="rezerwacjaPomyslnie" style={{border: 'none'}} id='divToPrint'>
                <h2>Twoje bilety</h2>
                <h5>ID transakcji: {this.props.match.params.transakcja}</h5>
                {!this.state.loading ? <div style={{marginTop: 50}}>
                        {this.state.bilety.length > 0 ? <div>
                            {this.state.bilety.map((item, index) => {
                                return <div
                                    className={"wynik"}>
                                    <div key={"kurs" + item.idKu} id={"bilet" + item.idBi}
                                         style={{marginLeft: 5, marginRight: 5}}
                                         className={"row"}>
                                        <div className="col-sm-2 text-center">
                                            <QRCode value={item.idBi.toString()} size={110}/>
                                            <div
                                                style={{
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                    textAlign: 'center'
                                                }}>
                                                <div className="czas" style={{paddingTop: 8}}>ID: <b>{item.idBi}</b>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-10">
                                            <div className="row">
                                                <div className="col-sm-1"
                                                     style={{
                                                         textAlign: 'right',
                                                         paddingLeft: 0,
                                                         paddingRight: 0,
                                                         maxWidth: 30
                                                     }}>
                                                    <div className="godzinaOdjazd"><i
                                                        className="fa fa-arrow-right"
                                                        style={{fontSize: '1.25rem', paddingTop: 0}}> </i>
                                                    </div>
                                                    <div className="godzinaPrzyjazd"><i
                                                        className="fa fa-arrow-left"
                                                        style={{fontSize: '1.25rem', paddingTop: 0, color: '#eeb207'}}> </i>
                                                    </div>
                                                </div>
                                                <div className="col-sm-5 text-left"
                                                     style={{paddingLeft: 15, paddingRight: 5}}>
                                                    <div className="miejsceOdjazd">{item.nazMiOd}
                                                        <span> {item.nazPrOd}</span></div>
                                                    <div className="miejscePrzyjazd">{item.nazMiDo}
                                                        <span> {item.nazPrDo}</span></div>
                                                </div>
                                                <div className="col-sm-4" style={{textAlign: 'left'}}>
                                                    <div className="row">
                                                        <div
                                                            className="czas col-6"
                                                            style={{paddingTop: 8}}><b>{this.checkWazny(item)}</b>
                                                        </div>
                                                        <div
                                                            className="czas col-6"
                                                            style={{paddingTop: 8}}><b>{this.checkWaznyCzas(item)}</b>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="czas"
                                                        style={{paddingTop: 8}}>Klient: <b>{item.klient}</b></div>
                                                </div>
                                                <div className="col-sm-2"
                                                     style={{
                                                         paddingLeft: 0,
                                                         paddingRight: 0,
                                                         textAlign: 'left'
                                                     }}>
                                                    <div className="czas" style={{paddingTop: 8}}>Typ: <b>{item.nazZniz}</b>
                                                    </div>
                                                    <div
                                                        className="cenaNormalny"
                                                        style={{paddingTop: 8}}>Cena: <span>{acc.formatMoney(item.cena, {
                                                        symbol: "zł",
                                                        format: "%v %s"
                                                    })}</span></div>
                                                </div>
                                            </div>
                                            <div className="row" style={{paddingRight: 25, paddingTop: 15}}>
                                                <div className="col-sm-6">
                                                    <div className="czas" style={{
                                                        paddingTop: 8,
                                                        fontSize: '0.875rem'
                                                    }}>Status: {this.checkStatus(item.statPoz)}</div>
                                                </div>
                                                <div className="col-sm-2 text-right">
                                                    <a href={(item.statPoz !== 1 && item.statPoz !== 0) ? '#' : AppConfig.HOST_API() + 'client/api/bilety/getpdf/' + item.idBi + '/' + this.props.match.params.transakcja + AppConfig.V_LOG()}><Button
                                                        bsStyle="success" bsSize="small"
                                                        disabled={(item.statPoz !== 1 && item.statPoz !== 0)}
                                                    ><i
                                                        className="fa fa-download"
                                                        style={{
                                                            color: 'white',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                            paddingLeft: 5,
                                                            paddingRight: 5
                                                        }}
                                                        aria-hidden="true"> </i>Pobierz
                                                        bilet</Button></a>
                                                </div>
                                                <div className="col-sm-2 text-center">
                                                    <a href={(item.statPoz !== 1 && item.statPoz !== 0) ? '#' : AppConfig.HOST_API() + 'client/api/bilety/getpdf/' + item.idBi + '/' + this.props.match.params.transakcja + '?download=false'  + AppConfig.V_LOG_SECOND_PARAM()}>
                                                        <Button bsStyle="info" bsSize="small"
                                                                disabled={(item.statPoz !== 1 && item.statPoz !== 0)}
                                                        ><i
                                                            className="fa fa-print"
                                                            style={{
                                                                color: 'white',
                                                                paddingTop: 2,
                                                                paddingBottom: 2,
                                                                paddingLeft: 5,
                                                                paddingRight: 5
                                                            }}
                                                            aria-hidden="true"> </i>Drukuj bilet</Button></a>
                                                </div>
                                                <div className="col-sm-2 text-left">
                                                    <Button bsStyle="danger" bsSize="small"
                                                            disabled={item.statPoz !== -1 && item.statPoz !== 0 && item.statPoz !== 1}
                                                            onClick={() => this.anulujBilet(item)}><i
                                                        className="fa fa-times"
                                                        style={{
                                                            color: 'white',
                                                            paddingTop: 2,
                                                            paddingBottom: 2,
                                                            paddingLeft: 5,
                                                            paddingRight: 5
                                                        }}
                                                        aria-hidden="true"> </i>Anuluj bilet</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                            }
                        </div> : null}
                    </div> :
                    <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>}
                <div style={{paddingTop: 10}}>
                    <b>UWAGA! W przypadku rezerwacji na przystanku należy pojawić się co najmniej 15 minut przed
                        odjazdem.</b>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/Transakcja.js